<div class="countdown" role="timer" aria-live="polite" aria-atomic="true">
    <h2 *ngIf="block.data.header" class="countdown__header">{{block.data.header}}</h2>

    <time class="countdown__timer">
        <span class="countdown__time countdown__time--days">
            <span class="countdown__unit" [innerHTML]="days || '00'"></span>
            <span class="countdown__label">Days</span>
        </span>

        <span class="countdown__time countdown__time--hours">
            <span class="countdown__unit" [innerHTML]="hours || '00'"></span>
            <span class="countdown__label">Hours</span>
        </span>

        <span class="countdown__time countdown__time--minutes">
            <span class="countdown__unit" [innerHTML]="minutes || '00'"></span>
            <span class="countdown__label">Min<span class="countdown__whole-word">utes</span></span>
        </span>

        <span class="countdown__time countdown__time--seconds">
            <span class="countdown__unit" [innerHTML]="seconds || '00'"></span>
            <span class="countdown__label">Sec<span class="countdown__whole-word">onds</span></span>
        </span>
    </time>
</div>
